import React from 'react';
import { Space, Tabs, Typography } from 'antd';
import { AdministrationItem } from './BackOfficeItem';

export const Administration = () => {
  const tabItems = [
    {
      key: '1',
      label: `All`,
      children: <AdministrationItem />,
    },
    {
      key: '2',
      label: `Admin`,
      children: <AdministrationItem role={'Admin'} />,
    },
    {
      key: '3',
      label: `Maker`,
      children: <AdministrationItem role={'Maker'} />,
    },
    {
      key: '4',
      label: `Checker`,
      children: <AdministrationItem role={'Checker'} />,
    },
  ];
  return (
    <Space direction="vertical" size={'large'} style={{ width: '100%' }}>
      {/* {tabItems.keys === '1' ? (
        <Title level={4} style={{ margin: 0 }}>
          Individual Account Opening
        </Title>
      ) : (
        <Title level={4} style={{ margin: 0 }}>
          Corporate Account Opening
        </Title>
      )} */}
      <AdministrationItem />
      {/* <Tabs defaultActiveKey="1" items={tabItems} /> */}
    </Space>
  );
};
